<div class="host-search-house-in-group-and-type-with-input">
  <div
    #houseSelectModal
    class="date"
    [style.border-radius]="borderRadius"
    nz-dropdown
    [nzDropdownMenu]="menu"
    [nzBackdrop]="false"
    [(nzVisible)]="open"
    nzTrigger="click"
  >
    <div
      class="custom-component-display-frame border"
      [style.border-radius]="borderRadius"
    >
      <div
        *ngIf="houseInfo !== null"
        class="normal-text"
        [style.width]="showWidth ? showWidth - 42 : 'auto'"
      >
        {{ houseInfo }}
      </div>
      <div
        *ngIf="houseInfo === null"
        class="placeholder"
        [style.width]="showWidth ? showWidth - 42 : 'auto'"
      >
        {{ "placeholder.house_optional" | translate }}
      </div>
    </div>
    <div class="icon">
      <div>
        <i nz-icon [nzType]="open ? 'up' : 'down'" nzTheme="outline" style="zoom: 85%; color: rgba(0, 0, 0, 0.25);"
        ></i>
      </div>
    </div>
  </div>
</div>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="template">
    <host-search-houses-with-group-and-type
      [allowMultiSelect]="allowMultiSelect"
      [houseGroupList]="houseGroupList"
      [houseTypeList]="houseTypeList"
      [allHouseList]="allHouseList"
      [defaultHouses]="defaultHouses"
      [noBorder]="true"
      (checkedHousesChange)="selectedHousesChange($event)"
      (groupChange)="groupChange($event)"
      (typeChange)="typeChange($event)"
    ></host-search-houses-with-group-and-type>
    <div class="footer">
      <button nz-button (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzType="primary" (click)="save()">
        {{ "word.confirm" | translate }}
      </button>
    </div>
  </div>
</nz-dropdown-menu>
<!-- <ng-template #houseSelectPanel>
  <div class="template">
    <host-triggerSearch-houses-with-group-and-type
      [allowMultiSelect]="allowMultiSelect"
      [houseGroupList]="houseGroupList"
      [houseTypeList]="houseTypeList"
      [allHouseList]="allHouseList"
      [defaultHouses]="defaultHouses"
      [noBorder]="true"
      (checkedHousesChange)="selectedHousesChange($event)"
      (groupChange)="groupChange($event)"
      (typeChange)="typeChange($event)"
    ></host-triggerSearch-houses-with-group-and-type>
    <div class="footer">
      <button nz-button (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzType="primary" (click)="save()">
        {{ "word.confirm" | translate }}
      </button>
    </div>
  </div>
</ng-template> -->
